import React from 'react';
import { connect } from 'react-redux';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { wrap, mainContent, backdrop } from '../components/styles';
import { AppState } from '../redux-modules/root';
import { CircularProgress, Backdrop } from '@material-ui/core';

import { ContainerProps } from './Container';
import * as client from '../redux-modules/client';
import * as dynamicclient from '../redux-modules/dynamicclient';
import * as family from '../redux-modules/family';
import * as Types from '../api/definitions';

import { KeyUpService } from '../Services/KeyUpService';
import { domainPath } from '../App';
import FamilyDetails from '../components/FamilySearchComponent/FamilyDetails';
interface MatchParams {
    index: string;
}
export interface DynamicFamilyDetailsContainerState {
    isLoading: boolean;
    error: string;
    hasError: boolean;
}
export interface DynamicFamilyDetailsContainerProps extends ContainerProps<MatchParams>, WithSnackbarProps {
    updateProgramCompletion2: (client: Types.DynamicClient) => Promise<string>;
    // getAvailablePrograms: () => Promise<void>;
    submitPrediction: (client: Types.Client) => Promise<void>;
    getLocations: (client_code: string, selected_program: string, is_accessToken: any) => Promise<void>;
    getPcr: (client_code: string, selected_program: string) => Promise<void>;
    DsaveLocationAndProgram: (
        selected_location: string,
        selected_program: string,
        client_code: string
    ) => Promise<void>;
    clearErrors: () => void;
    clearClient: () => void;
    getProgramsForClient: (client_code: string, version: string) => Promise<void>;
    updateFormValues: (client_code: string, values: any) => void;
    // getReferral: () => Promise<void>;
    Referral: Types.Referral[];
    getSearchFields: (config: string, subConfig: string, is_accessToken: string) => void;
    getSearchRecord: (is_accessToken: string, Config: string, subConfig: string, keySearch: string, _id?: string) => void;
}

export class DynamicFamilyDetailsContainer extends React.Component<
    DynamicFamilyDetailsContainerProps,
    DynamicFamilyDetailsContainerState
> {
    constructor(props: DynamicFamilyDetailsContainerProps) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            isLoading: false,
            hasError: false,
            error: '',
        };
    }

    async componentDidMount() {
        await this.loadClientDetails();
    }

    loadClientDetails = async () => {
        const org_type: any = this.props && this.props.user && this.props.user.user && this.props.user.user.org_type;
        const locationVersionComplete =
            this.props && this.props.location && (this.props.location.state as Types.CustomizedHistoryState);
        const is_accessToken: string | any = this.props.user && this.props.user.user.accessToken;
        const locationVersion: string = locationVersionComplete?.version;
        const recordId: string = locationVersionComplete?._id;
        const versionIndex: any =
            locationVersion &&
            (parseInt(locationVersion.substring(1)) > 0
                ? parseInt(locationVersion.substring(1)) - 1
                : parseInt(locationVersion.substring(1)));

        const { client: clientState, family: familyState } = this.props;
        const familyList = (familyState && familyState.familyList) || {};
        const { index } = this.props.match.params;
        this.setState({ isLoading: true });

        try {
            const { Config, subConfig } = KeyUpService.getConfSubConf(this.props.location.pathname);
            let searchFields: any = await this.props.getSearchFields(Config, subConfig, is_accessToken);

            let version = '';
            if (familyList[index] || index) {
                if (searchFields?.length > 0) {
                    const uniqueField: any = (familyState && familyState.familyUniqueId) || '';
                    let data: any = { [uniqueField]: index };
                    await this.props.getSearchRecord(is_accessToken, Config, subConfig, uniqueField, recordId);
                }
            }
            this.setState({ isLoading: false });
            this.props.closeSnackbar();
        } catch (errors) {
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar('An error occured. Please try again.');
        }

    };

    updateProgramCompletion2 = async (clientForm: Types.DynamicClient) => {
        try {
            this.setState({ isLoading: true });
            await this.props.updateProgramCompletion2(clientForm);
            this.setState({
                isLoading: false
            });
            this.props.enqueueSnackbar('Data saved successfully.');
        } catch (error) {
            console.log(error);
            this.setState({
                isLoading: false
            });
            this.props.enqueueSnackbar('An error occured. Please try again.');
        }
    };

    getVersionDetails = async (client_code: string, version: string) => {
        this.setState({ isLoading: true });
        await this.props.getProgramsForClient(client_code, version);
        this.setState({ isLoading: false });
    };
    submitProgram = async (client: Types.Client) => {
        if (!client.client_code) {
            this.props.enqueueSnackbar('Error. Client information is required to process this form.');
            return false;
        }
        try {
            this.setState({ isLoading: true });
            await this.props.submitPrediction(client);
        } catch (error) {
            let errorMessage: string = 'An error occurred while saving.';
            if (error['referred_program']) {
                errorMessage = error['referred_program'][0];
            } else if (error.message) {
                errorMessage = error.message;
            }
            this.props.enqueueSnackbar(errorMessage);
        }
        this.setState({ isLoading: false });
    };

    render() {
        const { client: clientState, family: familyState, referral: referralState } = this.props;
        const referralList = (referralState && referralState.referralList) || [];
        const familyList = (familyState && familyState.familyList) || {};
        const { index, Config, subConfig } = KeyUpService.getConfSubConf(this.props.location.pathname);
        const is_role_type: any = this.props.user && this.props.user.user.role_type;
        const uniqueIdField: any = (familyState && familyState.familyUniqueId) || '';
        const searchData: any =
            this.props && this.props.family && this.props.family.searchData && this.props.family.searchData || [];
        const org_type = this.props && this.props.user && this.props.user.user && this.props.user.user.org_type;
        //Find Version : 1. Open through Notifications -> Notifications version,
        //Find Version : 2. Open through Search Client -> Last Version
        // const locationVersion =
        //     this.props && this.props.location && this.props.location.state && this.props.location.state.version;
        const locationVersionComplete =
            this.props && this.props.location && (this.props.location.state as Types.CustomizedHistoryState);
        const locationVersion: string = locationVersionComplete?.version;
        const versionIndex = locationVersion
            ? parseInt(locationVersion.substring(1)) > 0
                ? parseInt(locationVersion.substring(1)) - 1
                : parseInt(locationVersion.substring(1))
            : searchData && searchData?.length - 1;
        const refferalInfo: any = this.props.user && this.props.user.user.referral_info;

        if (searchData?.length > 0 && familyList[index]) {
            return (
                <div css={wrap}>
                    <div css={mainContent}>
                        {!familyList[index] ? null : (
                            <FamilyDetails
                                searchData={searchData?.filter((s) => s[uniqueIdField]?.toString() === index?.toString())}
                                is_role_type={is_role_type}
                                family={familyList[index]}
                                index={index}
                                DynamicQuestions={familyList[index].sections.filter(
                                    (sec) => sec.section === 'Outcomes'
                                )}
                                {...this.state}
                                org_type={org_type}
                                onFormSubmit={this.updateProgramCompletion2}
                                uniqueIdField={uniqueIdField}
                                configType={Config}
                                subConfigType={subConfig}
                                refferalInfo={refferalInfo}
                            />
                        )}
                    </div>
                </div>
            );
        } else {
            return (
                <div css={wrap}>
                    <div css={mainContent}>
                        <Backdrop css={backdrop} open={true}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20%' }}>
                                &nbsp;&nbsp;
                                <CircularProgress color="inherit" />
                            </div>
                        </Backdrop>
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = (state: AppState) => {
    return {
        client: state.client,
        family: state.family,
        program: state.program,
        referral: state.referral,
        user: state.user
    };
};

const mapDispatchToProps = {
    submitPrediction: client.actions.submitPrediction,
    getLocations: dynamicclient.actions.getLocations,
    clearErrors: client.actions.clearErrors,
    clearClient: client.actions.clear,
    updateFormValues: dynamicclient.actions.updateFormValues,
    getSearchRecord: family.actions.getSearchRecord,
    getSearchFields: family.actions.getSearchFields,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DynamicFamilyDetailsContainer));